class SGPopup extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sizeChartData = [
      { size: "XS", order: 1, bust: [78, 80], waist: [59, 61], hip: [87, 89] },
      { size: "S", order: 2, bust: [83, 85], waist: [64, 66], hip: [92, 94] },
      { size: "M", order: 3, bust: [88, 90], waist: [69, 71], hip: [97, 99] },
      { size: "L", order: 4, bust: [93, 95], waist: [74, 76], hip: [102, 104] },
      {
        size: "XL",
        order: 5,
        bust: [98, 100],
        waist: [79, 81],
        hip: [107, 109],
      },
    ];
    this.openBtn = document.querySelector(".size-chart-toggle");
    this.modal = this;
    this.closeBtn = this.querySelector(".sg-close-btn");
    this.tabBtns = this.querySelectorAll(".sg-tab-btn");
    this.tabContents = this.querySelectorAll(".sg-tab-content");
    this.sgInputs = this.querySelectorAll(".sg-input-wrapper input");
    this.continueBtn = this.querySelector(".ks-calculator-button");
    this.closeBtn.addEventListener("click", () => {
      this.modal.style.display = "none";
    });
    this.openBtn.addEventListener("click", () => {
      this.modal.style.display = "flex";
    });
    this.continueBtn.addEventListener("click", () => {
      this.modal.style.display = "none";
    });
    window.addEventListener("click", (event) => {
      if (event.target === this.modal) {
        this.modal.style.display = "none";
      }
    });
    // Chuyển Tab (Calculate My Size <-> Size Chart)
    this.tabBtns.forEach((tab) => {
      tab.addEventListener("click", () => {
        const targetTab = tab.getAttribute("data-tab");

        this.tabBtns.forEach((t) => t.classList.remove("active"));
        this.tabContents.forEach((c) => c.classList.remove("active"));

        tab.classList.add("active");
        document.getElementById(`tab-${targetTab}`).classList.add("active");
      });
    });
    this.sgInputs.forEach((input) => {
      input.addEventListener("keyup", this.findSize.bind(this));
    });
  }
  findSize() {
    let bust = this.querySelector("#sgBust").value;
    let waist = this.querySelector("#sgWaist").value;
    let hip = this.querySelector("#sgHip").value;
    if (bust == "" || waist == "" || hip == "") return;
    let size = this.getRecommendedSize(bust, waist, hip, this.sizeChartData);
    this.querySelector(".formula-text").innerText = size;
    this.querySelector(".ks-calculator-element").style.display = "block";
  }
  findSizeForMeasurement(value, key, chart) {
    // value <= max cua size dau tien gap -> tra size do
    // value nho hon moi range -> size nho nhat (XS)
    // value lon hon moi range -> size lon nhat (XL)
    // value roi vao "khoang trong" giua 2 size -> lam tron LEN size lon hon
    for (const row of chart) {
      if (value <= row[key][1]) return row.size;
    }
    return chart[chart.length - 1].size; // fallback: XL
  }

  getRecommendedSize(bust, waist, hip, chart) {
    const sizes = [
      this.findSizeForMeasurement(bust, "bust", chart),
      this.findSizeForMeasurement(waist, "waist", chart),
      this.findSizeForMeasurement(hip, "hip", chart),
    ];
    const orderOf = (s) => chart.find((r) => r.size === s).order;
    // Quy tac: lay size co "order" lon nhat (size lon nhat trong 3 ket qua)
    return sizes.reduce((max, s) => (orderOf(s) > orderOf(max) ? s : max));
  }
}
customElements.define("sg-popup", SGPopup);
document.addEventListener("DOMContentLoaded", () => {
  // Chuyển đổi đơn vị linh hoạt (CM / INCHES)
  const unitToggles = document.querySelectorAll(".sg-unit-toggle");

  unitToggles.forEach((toggle) => {
    const btns = toggle.querySelectorAll(".sg-unit-btn");
    const scope = toggle.getAttribute("data-scope");

    btns.forEach((btn) => {
      btn.addEventListener("click", () => {
        btns.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");

        const unit = btn.getAttribute("data-unit");

        // Nếu là Tab Calculator
        if (scope === "calc") {
          const unitLabels = document.querySelectorAll(
            "#tab-calc .sg-unit-text",
          );
          unitLabels.forEach((label) => {
            label.textContent = unit === "cm" ? "cm" : "in";
          });
        }
        // Nếu là Bảng 1 trong Size Chart
        else if (scope === "chart-product") {
          convertTableValues(
            document.getElementById("productMeasurementsTable"),
            unit,
          );
        }
        // Nếu là Bảng 2 trong Size Chart
        else if (scope === "chart-body") {
          convertTableValues(
            document.getElementById("sizeGuideBodyTable"),
            unit,
          );
        }
      });
    });
  });

  // Hàm chuyển đổi giá trị bảng từ CM <-> INCHES
  function convertTableValues(table, targetUnit) {
    if (!table) return;
    const cells = table.querySelectorAll("td[data-cm]");

    cells.forEach((cell) => {
      const cmVal = parseFloat(cell.getAttribute("data-cm"));
      if (isNaN(cmVal)) return;

      if (targetUnit === "in") {
        // 1 cm = 0.393701 inches
        const inchVal = (cmVal * 0.393701).toFixed(1);
        cell.textContent = inchVal;
      } else {
        cell.textContent = cmVal;
      }
    });
  }

  const sentinel = document.getElementById("infinite-scroll-sentinel");
  const productGrid = document.querySelector(".grid-collection__container");

  if (
    !document.body.classList.contains("template-collection") ||
    !sentinel ||
    !productGrid
  )
    return;

  let isLoading = false;

  // Hàm tải trang kế tiếp
  const loadNextPage = async () => {
    const nextUrl = sentinel.getAttribute("data-next-url");
    if (!nextUrl || isLoading) return;

    isLoading = true;

    try {
      const response = await fetch(nextUrl);
      const htmlText = await response.text();

      const parser = new DOMParser();
      const nextDoc = parser.parseFromString(htmlText, "text/html");

      const newProducts = nextDoc.querySelectorAll(
        ".grid-collection__container .grid-product-item",
      );
      const newSentinel = nextDoc.getElementById("infinite-scroll-sentinel");

      // Chèn sản phẩm mới vào grid
      newProducts.forEach((product) => productGrid.appendChild(product));

      // Cập nhật URL trang tiếp theo hoặc ngắt kết nối nếu hết sản phẩm
      if (newSentinel) {
        sentinel.setAttribute(
          "data-next-url",
          newSentinel.getAttribute("data-next-url"),
        );
      } else {
        observer.disconnect();
        sentinel.remove();
      }
    } catch (error) {
      console.error("Lỗi khi tải sản phẩm:", error);
    } finally {
      isLoading = false;
    }
  };

  // Cấu hình IntersectionObserver
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        // Khi thẻ sentinel xuất hiện trong góc nhìn (viewport)
        if (entry.isIntersecting) {
          loadNextPage();
        }
      });
    },
    {
      // Tải trước khi người dùng cuộn đụng đáy 300px để trải nghiệm mượt mà hơn
      rootMargin: "0px 0px 300px 0px",
    },
  );

  observer.observe(sentinel);
});
